<template>
  <div v-if="articles.length > 0" class="category-page-media">
    <h2
      class="category-page__media-title"
      id="video-box"
    >
      {{ $t('category-page.media-block.title') }}
    </h2>

    <div v-if="!isSwiperEnabled" class="category-page-media__content">
      <div
        v-if="ArticlesComputed.length"
        class="category-page-media__articles"
      >
        <a
          v-for="(article, index) in ArticlesComputed"
          :key="index"
          :href="article.article_link"
          class="article"
        >
          <img
            :src="article.article_img"
            alt=""
            class="article__img"
          >
        </a>
      </div>
    </div>

    <div v-else class="swiper-wrapper">
      <swiper
        class="category-page-media__content"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(article, index) in ArticlesComputed"
          :key="index"
          class="category-page-media__article-slide"
        >
          <a :href="article.article_link" class="article">
            <img
              :src="article.article_img"
              alt=""
              class="article__img"
            >
          </a>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, Navigation } from 'vue-awesome-swiper'

export default {
  name: 'CategoryMedia',

  components: {
    Swiper,
    SwiperSlide
  },

  props: {
    videoUrl: {
      type: String,
      default: null
    },
    articles: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      isMobile: false
    }
  },

  computed: {
    ArticlesComputed () {
      return this.articles?.slice(0, 5) || []
    },

    swiperOptions () {
      return {
        loop: false,
        spaceBetween: 10,
        preloadImages: false,
        lazy: true,
        slidesPerView: 'auto',
        freeMode: true,
        grabCursor: true,
        breakpoints: {
          768: {
            modules: [Navigation],
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            spaceBetween: 20,
            slidesPerView: '3',
            enabled: this.isSwiperEnabled
          }
        }
      }
    },
    isSwiperEnabled () {
      return this.isMobile || this.articles?.length > 3
    }
  },

  mounted () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize () {
      this.isMobile = window.innerWidth <= 768
    }
  }
}
</script>

<style scoped lang="sass">
::v-deep .main-video
  height: 100%
  padding-bottom: 0

a, p
  all: unset

.category-page__media-title
  margin-bottom: 30px

.category-page-media
  display: flex
  flex-direction: column
  margin-bottom: 60px

  &__content
    display: flex
    justify-content: center
    gap: 20px
    width: 100%

  /* DESKTOP */
  &__video
    flex: 860 1 0
    aspect-ratio: 860 / 210
    max-width: 860px

  &__articles
    flex: 210 1 0
    display: flex
    flex-direction: row
    gap: 20px

  /* MOBILE */
  &__video-slide
    width: 300px

  &__article-slide
    width: 300px

.article
  display: flex
  overflow: hidden
  cursor: pointer
  aspect-ratio: 520/230
  width: 100%
  background: #f2f2f2

  &__img
    object-fit: cover

@media screen and (max-width: 768px)
  .category-page__media-title
      margin-bottom: 20px
  .category-page-media
    margin-bottom: 40px
    &__content
      height: 170px
  .swiper-button-prev,
  .swiper-button-next
    display: none

::v-deep .swiper-button-prev,
::v-deep .swiper-button-next
  color: #000
  width: 30px
  height: 30px
  position: absolute
  color: #333333
  z-index: 1
  background-color: #ffffff
  border: 1px solid #E7E7E7
  border-radius: 3px
  outline: none
  top: -30px
  &:hover
    border-color: #ff2f00

::v-deep .swiper-button-prev::after,
::v-deep .swiper-button-next::after
  font-size: 16px

.swiper-wrapper
  position: relative

.swiper-button-prev
  right: 40px
  left: auto

.swiper-button-next
  right: 0

</style>
